import { render } from "./ArticleOverview.vue?vue&type=template&id=382870ba"
import script from "./ArticleOverview.vue?vue&type=script&lang=js"
export * from "./ArticleOverview.vue?vue&type=script&lang=js"

import "./ArticleOverview.vue?vue&type=style&index=0&id=382870ba&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__